<template>
  <div>
    <v-toolbar flat color="transparent" style="background: transparent">
      <v-toolbar-title>
        <v-btn
          v-if="
            !(
              ['AutofbLogin', 'AutolineLogin', 'ConnectLine'].includes($route.name) &&
              currentView == 'select-channel'
            ) || currentView != 'select-channel'
          "
          flat
          @click="goBack"
          :loading="loading"
          style="line-height: 10px;"
        >
          <span class="fas fa-chevron-left mr-2"></span>
          {{ $t('Back') }}
        </v-btn>
      </v-toolbar-title>
      <v-spacer></v-spacer>

      <lang-dropdown v-if="['AutofbLogin', 'AutolineLogin'].includes($route.name)"></lang-dropdown>
    </v-toolbar>

    <v-container>
      <template v-if="currentView == 'select-channel'">
        <div class="text-xs-center">
          <h2 style="margin-bottom: 25px;">
            {{ $t('Select channel to connect your chatbot') }}
          </h2>

          <p style="margin_top: 45px; margin-bottom: 25px;">
            {{ $t("Only Admin page can install Chatbot. The page doesn't show up") }}
          </p>
        </div>

        <v-layout wrap>
          <v-flex xs12 sm4>
            <!-- <template v-if="availableChannels.includes('facebook')"> -->
            <div class="pa-1">
              <template v-if="!$store.state.facebook_info">
                <a class="decorate-none" :href="facebookUrl">
                  <div class="text-xs-center login-btn2 fb py-4 white--text">
                    <div>
                      <i
                        class="fab fa-facebook-square mr-2 login-btn2 fb"
                        style="font-size: 12.3rem;"
                      ></i>
                      <h2 class="login-btn2 fb">Choose Facebook account to connect</h2>
                    </div>
                  </div>
                </a>
              </template>
              <template v-else>
                <a
                  @click="
                    channel = 'fb'
                    currentView = 'select-page'
                    stage = 'select-page'
                  "
                  class="decorate-none"
                >
                  <div class="text-xs-center login-btn2 fb py-3 white--text">
                    <i
                      class="fab fa-facebook-square mr-2 login-btn2 fb"
                      style="font-size: 12.3rem;"
                    ></i>
                    <h2 class="login-btn2 fb">Choose Facebook account to connect</h2>
                  </div>
                </a>
              </template>
            </div>
            <!-- </template> -->
          </v-flex>
          <v-flex xs12 sm4>
            <div class="pa-1">
              <a :href="lineUrl" class="decorate-none">
                <div class="text-xs-center login-btn2 line py-3 white--text">
                  <i class="fab fa-line mr-2 login-btn2 line" style="font-size: 12.3rem;"></i>
                  <h2 class="login-btn2 line">Choose LINE OA to connect</h2>
                </div>
              </a>
            </div>
          </v-flex>
          <v-flex xs12 sm4>
            <div class="pa-1">
              <div @click="launchWhatsAppSignup" class="decorate-none" style="cursor:pointer">
                <div class="text-xs-center login-btn2 line py-3 white--text">
                  <i class="fab fa-whatsapp mr-2 login-btn2 line" style="font-size: 12.3rem;"></i>
                  <h2 class="login-btn2 line">Choose WhatsApp to connect</h2>
                </div>
              </div>
            </div>
          </v-flex>
        </v-layout>
      </template>
      <template v-else-if="currentView == 'select-page'">
        <template v-if="channel == 'fb'">
          <template v-if="availablePages.length == 0">
            <v-container class="text-xs-center">
              <v-layout wrap>
                <v-flex xs12 sm6 offset-sm3>
                  <img
                    src="/static/img/assets/get_started/no_page.png"
                    alt
                    class="responsive-img"
                  />
                  <h2>{{ $t('You dont have any Facebook page or') }}</h2>
                  <h3>{{ $t('No permission to access Facebook page') }}</h3>
                  <v-btn
                    href="https://www.facebook.com/pages/creation/"
                    target="_blank"
                    block
                    class="mb-2 mt-2"
                    color="primary"
                  >
                    {{ $t('If you dont have any Facebook page, Create new page') }}</v-btn
                  >

                  <p>{{ $t('or') }}</p>

                  <v-btn @click="logout" block color="primary">
                    {{ $t('If you have page, Login again and Allow Facebook page permission') }}
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-container>
          </template>
          <template v-else>
            <transition
              enter-active-class="animated fadeIn"
              leave-active-class="animated fadeOut"
              mode="out-in"
            >
              <div v-if="stage == 'select-page'">
                <div class="text-xs-center">
                  <h2 class="primary--text" style="margin-bottom: 25px;">
                    {{ $t('Select your Facebook Page to install Zwiz.ai chatbot') }}
                    <!-- <template v-if="themelist.length > 0">
                  <span>{{themelist[0].themename}}</span>
                </template>-->
                  </h2>

                  <p style="margin_top: 45px; margin-bottom: 25px;">
                    {{ $t("Only Admin page can install Chatbot. The page doesn't show up") }}
                    <a
                      href="https://blog.zwiz.ai/%E0%B8%96%E0%B9%89%E0%B8%B2%E0%B9%80%E0%B8%9E%E0%B8%88%E0%B8%97%E0%B8%B5%E0%B9%88%E0%B8%95%E0%B9%89%E0%B8%AD%E0%B8%87%E0%B8%81%E0%B8%B2%E0%B8%A3%E0%B8%95%E0%B8%B4%E0%B8%94%E0%B8%95%E0%B8%B1%E0%B9%89/"
                      target="_blank"
                      rel="noopener noreferrer"
                      >{{ $t('click') }}</a
                    >
                  </p>
                </div>

                <div class="pages">
                  <div v-for="(page, index) in computedPage" :key="'page_' + page.id">
                    <page-item v-model="computedPage[index]" class="page">
                      <div
                        slot="select-page"
                        style="position: absolute; top: 0; left: 0; right: 0; bottom: 0; "
                        @click="onConfirmSubscribe(page)"
                        v-if="stage == 'select-page'"
                      ></div>
                    </page-item>
                  </div>
                </div>
                <div class="text-xs-center mt-2">
                  <v-btn
                    @click="logout"
                    block
                    outline
                    color="primary"
                    style="width: auto; display: unset;"
                  >
                    {{ $t('page_does_not_appear_login_again') }}
                  </v-btn>
                </div>
              </div>
            </transition>
          </template>
        </template>

        <div v-if="stage == 'confirm-install'">
          <div class="text-xs-center">
            <h2 style="margin-bottom: 25px;">
              {{
                currentPage.channel == 'fb'
                  ? $t('chatbot will be installed to page')
                  : $t('chatbot will be installed to')
              }}
            </h2>
          </div>
          <v-card style="max-width: 300px; margin: auto; border-radius: 20px; ">
            <v-card-text class="text-xs-center pt-5">
              <div>
                <v-avatar
                  :size="150"
                  color="grey lighten-4"
                  style="margin: auto; border: 1px solid #eee"
                  class="elevation-2"
                >
                  <template v-if="currentPage.channel == 'line'">
                    <img
                      class="circle"
                      :src="currentPage.pagelogo || '/static/img/assets/livechat/profile.png'"
                      alt
                    />
                  </template>
                  <img
                    v-else-if="currentPage.channel == 'fb'"
                    class="circle"
                    :src="
                      'https://graph.facebook.com/' +
                        currentPage.id +
                        '/picture?width=100&height=100&SameSite=None'
                    "
                    alt
                  />
                  <template v-else>
                    <img
                      class="circle"
                      :src="currentPage.pagelogo || '/static/img/assets/livechat/profile.png'"
                      alt
                    />
                  </template>
                </v-avatar>
                <h3 class="primary--text mt-4 mb-5 text-truncate">
                  {{ currentPage.name }}
                </h3>
                <span class="page-role">
                  <template v-if="!currentPage.isAdmin">{{ $t('No permission') }}</template>
                  <template v-else>{{ pagerole }}</template>
                </span>
                <v-btn
                  large
                  color="primary"
                  :loading="loading"
                  :disabled="loading"
                  @click="onSubscribeBot"
                  depressed
                  class="ma-0"
                  style="width: 100%; margin-top: 25px;border-radius: 50px;"
                  >{{ $t('install bot') }}</v-btn
                >
              </div>
            </v-card-text>
          </v-card>
        </div>
      </template>
    </v-container>
  </div>
</template>

<script>
import api from '@/api'
import config from '@/config'
import Velocity from 'velocity-animate'
import { mapGetters } from 'vuex'
import PageItem from '@/components/view/allbots/PageItem'

import LangDropdown from '@/components/elements/LangDropdown'
import queryString from 'query-string'

import AES from 'crypto-js/aes'
import crypto from 'crypto-js'

window.fbAsyncInit = function() {
  // JavaScript SDK configuration and setup
  FB.init({
    appId: config.appid, // Facebook App ID
    cookie: true, // enable cookies
    xfbml: true, // parse social plugins on this page
    version: 'v15.0' //Graph API version
  })
}

// Load the JavaScript SDK asynchronously
;(function(d, s, id) {
  var js,
    fjs = d.getElementsByTagName(s)[0]
  if (d.getElementById(id)) return
  js = d.createElement(s)
  js.id = id
  js.src = 'https://connect.facebook.net/en_US/sdk.js'
  fjs.parentNode.insertBefore(js, fjs)
})(document, 'script', 'facebook-jssdk')

// Facebook Login with JavaScript SDK

export default {
  props: {
    value: {}
  },
  data: function() {
    return {
      currentView: 'select-channel',
      stage: 'select-channel',
      currentPageIndex: null,
      currentPage: null,
      themelist: [],
      selectedTheme: {
        themeid: 'ecommercebasic',
        themename: 'Ecommerce Basic',
        description: '',
        themepic: '',
        ispublic: true
      },
      lineUrl: '',
      facebookUrl: '',
      channel: null,
      loading: false
    }
  },
  components: {
    PageItem,
    LangDropdown
  },
  async mounted() {
    let vm = this

    if (this.value && this.computedPage.length > 0) {
      let pages = this.allPage.map(el => ({ ...el, isAdmin: true }))
      var currentPage = pages.find(el => {
        return el.id == this.value
      })

      if (currentPage) {
        currentPage.channel = 'line'
        this.currentPage = currentPage
        this.currentPageIndex = currentPage.id || null
        this.currentView = 'select-page'
        this.channel = 'line'
        this.stage = 'confirm-install'
      }
    }

    let query = []
    let state = {
      userid: this.$store.state.userid,
      lang: this.currentLang
    }
    for (const key in state) {
      if (key != 'state' && key) query.push(`${key}=${state[key]}`)
    }

    let encrypt_query = ''
    let querystring = query.join(',')
    encrypt_query = AES.encrypt(querystring, 'awesomezwizai').toString()

    // if (this.$store.state.line_info) {
    let line_connect_redirect_uri = `${window.location.protocol}//${window.location.hostname}${
      window.location.port ? ':' + window.location.port : ''
    }/connectline`

    this.lineUrl = `https://manager.line.biz/module/auth/v1/authorize?response_type=code&client_id=${this.$store.state.line.channelid}&redirect_uri=${line_connect_redirect_uri}&scope=account:manage%20message:mark_as_read%20message:receive%20message:send%20profile:read&state=${encrypt_query}`
    // } else {
    //   let line_redirect_url = `${window.location.protocol}//${window.location.hostname}${
    //     window.location.port ? ':' + window.location.port : ''
    //   }/autolinelogin`
    //   let nonce = crypto.lib.WordArray.random(16)

    //   this.lineUrl = `https://access.line.me/oauth2/v2.1/authorize?response_type=code&client_id=1656125305&redirect_uri=${encodeURIComponent(
    //     line_redirect_url
    //   )}&state=${encrypt_query}&scope=profile%20openid%20email&nonce=${nonce}`
    // }

    if (!this.$store.state.facebook_info) {
      let fb_redirect_uri = `${window.location.protocol}//${window.location.hostname}${
        window.location.port ? ':' + window.location.port : ''
      }/autofblogin`
      for (const key in this.$route.query) {
        if (key != 'state') query.push(`${key}=${this.$route.query[key]}`)
      }
      this.facebookUrl = `https://www.facebook.com/v10.0/dialog/oauth?client_id=${
        config.appid
      }&scope=${
        config.fb_scope
      }&return_scopes=true&response_type=token&redirect_uri=${encodeURIComponent(fb_redirect_uri)}`
      if (query.length > 0) this.facebookUrl = this.facebookUrl + `&state={${query.join(',')}}`
    }
  },
  computed: {
    ...mapGetters({
      botlist: 'botlist',
      isFacebook: 'isFacebook',
      allPage: 'allPage',

      selectedBot: 'selectedBot',
      currentLang: 'currentLang'
    }),
    availablePages() {
      let availablePages = this.$store.getters.availablePages
      availablePages = availablePages.filter(el => {
        return !el.isInstalled
      })
      return availablePages
    },
    availableChannels() {
      let channel = []
      if (this.$store.state.facebook_info || this.$store.state.fbAccessToken) {
        channel.push('facebook')
      }
      if (this.$store.state.line_info) {
        channel.push('line')
      }

      return channel
    },
    pagerole: function() {
      let vm = this
      var page = this.currentPage
      if (!this.currentPage) {
        return ''
      } else {
        // console.log(page)
        if (page.perms) {
          $.each(page.perms, function(index, val) {
            if (val == 'ADMINISTER') {
              return vm.$t('Administer')
            }
          })
        } else if (page.tasks) {
          $.each(page.tasks, function(index, val) {
            if (val == 'MANAGE') {
              return vm.$t('Administer')
            }
          })
        } else {
          return ''
        }
      }
    },
    computedPage: function() {
      var pages
      if (this.channel == 'fb') {
        pages = this.availablePages
      } else {
        pages = this.allPage
      }
      if (this.currentPageIndex == null) {
        this.currentPage = null
        return pages
      }
      try {
        return pages.filter(function(item) {
          if (item.id == this.currentPageIndex) {
            this.currentPage = item
          }
          return item.id == this.currentPageIndex
        })
      } catch (error) {
        console.error(error)
        return pages
      }
    },
    welcomeCustomerSays: {
      get() {
        let vm = this
        if (vm.welcome && vm.welcome.customerSay && vm.welcome.customerSay != '') {
          // console.log(vm.welcome.customerSay)
          var customerSays = []
          customerSays = vm.welcome.customerSay.split(',')
          var result = []
          $.each(customerSays, function(index, val) {
            result.push({ text: val })
          })
          return result
        } else {
          return []
        }
      },
      set(value) {
        let vm = this
        var result = []
        $.each(value, function(index, val) {
          result.push(val.text)
        })
        vm.welcome.customerSay = result.join(',')
      }
    },
    welcomeChoices: {
      get() {
        let vm = this
        if (vm.welcome && vm.welcome.choice && vm.welcome.choice != '') {
          // console.log(vm.welcome.choice)
          var choices = []
          choices = vm.welcome.choice.split(',')
          var result = []
          $.each(choices, function(index, val) {
            result.push({ text: val })
          })
          return result
        } else {
          return []
        }
      },
      set(value) {
        let vm = this
        var result = []
        $.each(value, function(index, val) {
          result.push(val.text)
        })
        vm.welcome.choice = result.join(',')
      }
    }
  },
  methods: {
    launchWhatsAppSignup() {
      const vm = this
      // Launch Facebook login
      window.FB.login(
        async function(response) {
          if (response.authResponse) {
            const accessToken = response.authResponse.accessToken
            console.log('Completed with token ' + accessToken)
            await vm
              .post(`whatsapp/new-subscribe`, { access_token: accessToken })
              .then(async res => {
                if (res.result.type === 'CREATE') {
                  vm.currentPageIndex = res.result.pageid
                  vm.currentPage = res.result
                  vm.currentPage.name = res.result.pagename
                  vm.currentPage.isAdmin = true
                  vm.currentPage.id = res.result.pageid
                  vm.channel = 'whatsapp'
                  vm.currentView = 'select-page'
                  vm.stage = 'confirm-install'
                  const data = {
                    userid: vm.$store.state.userid,
                    pageidlist: vm.botlist.map(el => el.pageid, []),
                    access_type: 'LINE_MODULAR'
                  }

                  await new Promise(resolve => setTimeout(resolve, 1000))
                  await vm.$store.dispatch('getBotlist', data)
                  // vm.$emit('close')
                } else {
                  let bot
                  if (res.result && res.result.pageid) {
                    bot = vm.botlist.find(el => el.pageid === res.result.pageid)
                  }
                  if (bot) {
                    vm.$store.dispatch('selectBot', bot)
                    await vm.$nextTick()
                    vm.$router.push({
                      path: '/' + vm.currentLang + '/home'
                    })
                  } else {
                    vm.$router.push({
                      path: '/' + vm.currentLang + '/allbots'
                    })
                  }
                }
              })

            //Use this token to call the debug_token API and get the shared WABA's ID
          } else {
            console.log('User cancelled login or did not fully authorize.')
          }
        },
        {
          scope: 'business_management,whatsapp_business_management,whatsapp_business_messaging',
          extras: {
            feature: 'whatsapp_embedded_signup',
            setup: {
              // Prefilled data can go here
            }
          }
        }
      )
    },
    onConfirmSubscribe(page) {
      const vm = this
      vm.stage = 'confirm-install'
      vm.currentPageIndex = page.id
      vm.currentPage = page
    },
    logout: function() {
      var vm = this
      var isFacebook = vm.isFacebook
      vm.$store.dispatch('logout', null).then()
      if (isFacebook) {
        localStorage.setItem('allowed_business_management', true)
        vm.$router.push('/' + vm.currentLang + '/login').catch(() => {})
      } else {
        vm.$router.push('/' + vm.currentLang + '/nigol').catch(() => {})
      }
    },
    async onSubscribeBot() {
      const vm = this
      if (vm.currentPageIndex == null || vm.selectedTheme == null || vm.loading) return
      
      vm.loading = true
      const data = {
        userid: vm.$store.state.userid,
        pageidlist: vm.botlist.map(el => el.pageid, []),
        access_token: vm.$store.state.fbAccessToken
      }
      await vm.$store.dispatch('getBotlist', data)

      if (vm.channel == 'fb') {
        vm.loading = true
        const page = vm.currentPage
        const data = {
          pageid: page.id,
          page_access_token: page.access_token,
          theme: vm.selectedTheme.themeid,
          pagename: page.name,
          ownerid: vm.$store.state.userid,
          facebook_name: vm.$store.state.facebook_name,
          status: false
        }

        // vm.$store.dispatch('addModalWelcome')
        api.newSubscribe(data, function(error, response) {
          if (error) {
            console.error(error)
            vm.loading = false
            return
          }

          vm.$store.dispatch('updateNewBotlist').then(
            function() {
              let bot = null
              $.each(vm.botlist, function(index, val) {
                if (val.pageid == page.id) {
                  bot = val
                  return false
                }
              })
              if (bot != null) {
                let utm = ''
                if (vm.$route.query.utm_source) {
                  utm = '_' + vm.$route.query.utm_source
                }
                let state = {}
                try {
                  const parsedHash = queryString.parse(vm.$route.hash)
                  state = vm.getState(parsedHash)

                  if (state && state.utm_source) {
                    utm = '_' + state.utm_source
                  }
                } catch (error) {
                  console.error(error)
                }
                vm.$store.dispatch('selectBot', bot)
                const prefix = 'z_'
                vm.$gtag.event(`${prefix}subscribe`, { event_category: bot.pagename + utm })
                if (
                  localStorage.getItem('loginBy') &&
                  typeof localStorage.getItem('loginBy') !== 'undefined'
                ) {
                  vm.$gtag.event(`${prefix}subscribe_${localStorage.getItem('loginBy')}`, {
                    event_category: bot.pagename + utm
                  })
                }

                const supportcode = vm.$route.query.supportcode
                  ? '?supportcode=' + vm.$route.query.supportcode
                  : ''
                vm.$router
                  .push({
                    path: '/' + vm.currentLang + '/setup' + supportcode,
                    query: { ...vm.$route.query, ...state }
                  })
                  .catch(() => {})
                vm.loading = false

                const getstarteddata = {
                  access_token: bot.page_access_token,
                  pageid: bot.pageid,
                  status: false,
                  getstarted_menu: {
                    get_started: {
                      payload: 'menu'
                    }
                  }
                }
                vm.savegetstartedmenu(getstarteddata).then(() => {})
              } else {
                vm.$emit('close')
                vm.loading = false
              }
            },
            function(error) {
              vm.$emit('close')
              vm.loading = false
              vm.errorMessage = 'Can not update chatbot'
            }
          )
        })
      } else if (vm.channel == 'line') {
        vm.loading = true
        const bot = vm.botlist.find(el => el.pageid == vm.currentPage.id)
        if (bot) {
          await vm.$store.dispatch('selectBot', bot)
          let utm = '',
            state = {}
          const prefix = window.location.hostname == 'cms.zwiz.app' ? 'z_' : ''
          vm.$gtag.event(prefix + 'line_subscribe', { event_category: bot.pagename + utm })

          const supportcode = vm.$route.query.supportcode
            ? '?supportcode=' + vm.$route.query.supportcode
            : ''
          await vm.$nextTick()
          vm.loading = false
          vm.$router
            .push({
              path: '/' + vm.currentLang + '/setup' + supportcode,
              query: { ...vm.$route.query, ...state }
            })
            .catch(() => {})
        } else {
          vm.loading = false
        }
      } else {
        vm.loading = true
        const bot = vm.botlist.find(el => el.pageid == vm.currentPage.id)
        if (bot) {
          await vm.$store.dispatch('selectBot', bot)
          let utm = '',
            state = {}
          const prefix = window.location.hostname == 'cms.zwiz.app' ? 'z_' : ''
          vm.$gtag.event(prefix + 'whatsapp_subscribe', { event_category: bot.pagename + utm })

          const supportcode = vm.$route.query.supportcode
            ? '?supportcode=' + vm.$route.query.supportcode
            : ''
          await vm.$nextTick()
          vm.loading = false
          vm.$router
            .push({
              path: '/' + vm.currentLang + '/setup' + supportcode,
              query: { ...vm.$route.query, ...state }
            })
            .catch(() => {})
        } else {
          vm.loading = false
        }
      }
    },
    savegetstartedmenu(data) {
      return new Promise((resolve, reject) => {
        api.savegetstartedmenu(data, function(error, response) {
          if (error) {
            reject(error)
            return
          }

          resolve(response)
        })
      })
    },
    goBack: function() {
      if (this.currentView == 'select-page') {
        this.currentView = 'select-channel'
      } else if (this.currentView == 'select-channel') {
        if (['AutofbLogin', 'AutolineLogin', 'ConnectLine'].includes(this.$route.name)) {
          this.$router
            .push('/' + (this.currentLang ? this.currentLang : 'th') + '/allbots')
            .catch(() => {})
        } else {
          this.$emit('close')
        }
      } else {
        this.$emit('close')
      }
    },
    beforeEnter: function(el) {
      el.style.opacity = 0
      // el.style.height = 0;
    },
    enter: function(el, done) {
      var delay = el.dataset.index * 250
      setTimeout(function() {
        Velocity(el, { opacity: 1 }, { complete: done })
      }, delay)
    },
    leave: function(el, done) {
      var delay = el.dataset.index * 250
      setTimeout(function() {
        Velocity(el, { opacity: 0 }, { complete: done })
      }, delay)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/getstarted/GetStarted.vue